import { render, staticRenderFns } from "./memberRecodeList.vue?vue&type=template&id=58773b6f&"
import script from "./memberRecodeList.vue?vue&type=script&lang=js&"
export * from "./memberRecodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports